module.exports = __webpack_public_path__ + "img/sumit_logo_2.63a3d5a5.svg";